import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import PointsOfInterestCreateForm from './PointsOfInterestCreateForm';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { createPointOfInterest } from 'store/actions/pointsofinterest/createPointsOfInterest';

class PointsOfInterestCreateContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            translate,
        } = this.props;

        const { localisation, ...base } = values;

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: (error) => {
                    let formErrors = {
                        _error: false,
                    };

                    if (error.response.message === 'location-could-not-be-resolved') {
                        formErrors.address = translate('forms.error.location-could-not-be-resolved');
                        formErrors._error = true;
                    }

                    if (formErrors._error) {
                        reject(new SubmissionError(formErrors));
                    }
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/pointsofinterest/${ id }/show`));
                },
                formValues: {
                    base,
                    localisation: utils.filterEmptyValues(localisation),
                },
            });
        });
    }

    render() {
        const {
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.points_of_interest.title'),
                link: '/pointsofinterest',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.points_of_interest.actions.create') } />

                    <Actions>
                        <ListButton url='/pointsofinterest' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PointsOfInterestCreateForm
                            form='points_of_interest_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PointsOfInterestCreateContainer.contextTypes = {
    config: PropTypes.object,
};

PointsOfInterestCreateContainer.propTypes = {
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(createPointOfInterest(values));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(PointsOfInterestCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/create/PointsOfInterestCreateContainer.js